import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { PLANIFICATION_STATUS } from '../../constants/enum';

const style = {
    blue: {
        color: '#02ADFF',
    },
    yellow: {
        color: '#FFFF00',
    },
    orange: {
        color: '#FFC000',
    },
    purple: {
        color: '#7030A0',
    },
    lightPurple: {
        color: '#7987FF',
    },
    burgundy: {
        color: '#C00000',
    },
    pink: {
        color: '#FFCCFF',
    },
    green: {
        color: '#00B050',
    },
    grey: {
        color: '#A6A6A6',
    },
};

const PlanificationStatusRenderer = (props) => {

    const translateStatus = (status) => {
        switch (status) {
            case PLANIFICATION_STATUS.NEW:
                return 'Nouveau';
            case PLANIFICATION_STATUS.AVAILABLE:
                return 'Nouveau';
            case PLANIFICATION_STATUS.ACCEPTED_PROVISIONAL:
                return 'Accepté prévisionnel';
            case PLANIFICATION_STATUS.ACCEPTED_CENTER:
                return 'Accepté centre';
            case PLANIFICATION_STATUS.CONFIRMED_CLIENT:
                return 'Confirmé client';
            case PLANIFICATION_STATUS.CONFIRMED_CENTERS:
                return 'Confirmé centres';
            case PLANIFICATION_STATUS.AGREEMENT_ISSUED:
                return 'Accord émis';
            case PLANIFICATION_STATUS.PASSAGE_MADE:
                return 'Passage effectué';
            case PLANIFICATION_STATUS.NOT_DONE:
                return 'Non effectué';
            case PLANIFICATION_STATUS.CANCELLED:
                return 'Annulé';
            case PLANIFICATION_STATUS.REFUSED:
                return 'Refusé';
            default:
                return 'Indisp.';
        }
    };

    const StatusRenderer = (props) => {
        const { status, askType } = props;

        switch (status) {
            case PLANIFICATION_STATUS.NEW:
                if (askType === 'wanted') {
                    return style.blue;
                } else if (askType === 'optional') {
                    return style.yellow;
                }
                break;
            case PLANIFICATION_STATUS.ACCEPTED_PROVISIONAL:
                return style.orange;
            case PLANIFICATION_STATUS.CONFIRMED_CLIENT:
                return style.burgundy;
            case PLANIFICATION_STATUS.CONFIRMED_CENTERS:
                return style.pink;
            case PLANIFICATION_STATUS.ACCEPTED_CENTER:
                return style.purple;
            case PLANIFICATION_STATUS.AGREEMENT_ISSUED:
                return style.green;
            case PLANIFICATION_STATUS.PASSAGE_MADE:
                return style.green;
            case PLANIFICATION_STATUS.NOT_DONE:
                return style.grey;
            case PLANIFICATION_STATUS.CANCELLED:
                return style.grey;
            case PLANIFICATION_STATUS.REFUSED:
                return style.grey;
            default:
                return style.grey;
        }
    };

    return <div>
        {props.displayIcon &&
            <FontAwesomeIcon icon={faCircle} style={props.data.type === PLANIFICATION_STATUS.UNAVAILABLE ? null : StatusRenderer({
                 status: props.data.metadata.status,
                 askType: props.data.metadata.askType,
             })} />
        }
        {(props.displayLabel || props.displayLabel === undefined) &&
            <span style={{ textTransform: 'uppercase', fontSize: '12px', marginLeft: 10 }}>{translateStatus(props.data.metadata.status)}</span>}
    </div>;

};

export default PlanificationStatusRenderer;
